"use strict";
import { mapState } from "vuex";

// eslint-disable-next-line
export default (Vue, options) => {
  Vue.mixin({
    computed: mapState({
      resx: state => state.locale.resx
    })
  });
};
